// Artwork extracted from the owner's approved SVG studies; provenance in ../artwork/SOURCES.md.
export const APPROVED_STYLE_DEFS = "<linearGradient id=\"panel\" x2=\"1\" y2=\"1\"><stop stop-color=\"#292532\"/><stop offset=\".55\" stop-color=\"#1d1e28\"/><stop offset=\"1\" stop-color=\"#1a1d26\"/></linearGradient>\n<linearGradient id=\"slot-fill\" x2=\".2\" y2=\"1\"><stop stop-color=\"#b5abc9\" stop-opacity=\".08\"/><stop offset=\"1\" stop-color=\"#b5abc9\" stop-opacity=\".025\"/></linearGradient>\n<radialGradient id=\"selected-fill\" cy=\".2\" r=\".9\"><stop stop-color=\"#dceca6\" stop-opacity=\".24\"/><stop offset=\"1\" stop-color=\"#dceca6\" stop-opacity=\".025\"/></radialGradient>\n<linearGradient id=\"hp-fill\"><stop stop-color=\"#bdcf8c\"/><stop offset=\"1\" stop-color=\"#edf2c1\"/></linearGradient>\n<linearGradient id=\"world-veil\" x2=\"0\" y2=\"1\"><stop stop-color=\"#10121c\" stop-opacity=\".4\"/><stop offset=\".23\" stop-color=\"#10121c\" stop-opacity=\"0\"/><stop offset=\".65\" stop-color=\"#10121c\" stop-opacity=\"0\"/><stop offset=\"1\" stop-color=\"#10121c\" stop-opacity=\".48\"/></linearGradient>\n<radialGradient id=\"weapon-shadow\"><stop stop-color=\"#10121d\" stop-opacity=\".6\"/><stop offset=\".5\" stop-color=\"#10121d\" stop-opacity=\".28\"/><stop offset=\"1\" stop-color=\"#10121d\" stop-opacity=\"0\"/></radialGradient>\n<radialGradient id=\"label-shadow\"><stop stop-color=\"#10121d\" stop-opacity=\".55\"/><stop offset=\".5\" stop-color=\"#10121d\" stop-opacity=\".24\"/><stop offset=\"1\" stop-color=\"#10121d\" stop-opacity=\"0\"/></radialGradient>\n<filter id=\"window-shadow\" x=\"-20%\" y=\"-20%\" width=\"150%\" height=\"150%\"><feDropShadow dx=\"0\" dy=\"16\" stdDeviation=\"20\" flood-color=\"#0b1017\" flood-opacity=\".4\"/></filter>\n<filter id=\"model-shadow\" x=\"-60%\" y=\"-60%\" width=\"220%\" height=\"220%\"><feDropShadow dx=\"0\" dy=\"4\" stdDeviation=\"4\" flood-color=\"#080a16\" flood-opacity=\".8\"/></filter>\n<filter id=\"hud-shadow\" x=\"-30%\" y=\"-60%\" width=\"160%\" height=\"220%\"><feDropShadow dx=\"0\" dy=\"1\" stdDeviation=\"2\" flood-color=\"#10141c\" flood-opacity=\".9\"/></filter>\n<filter id=\"inventory-fray\" x=\"-12%\" y=\"-12%\" width=\"124%\" height=\"124%\"><feTurbulence type=\"fractalNoise\" baseFrequency=\".042 .09\" numOctaves=\"2\" seed=\"12\" result=\"noise\"/><feDisplacementMap in=\"SourceGraphic\" in2=\"noise\" scale=\"8\" xChannelSelector=\"R\" yChannelSelector=\"G\"/></filter>\n<linearGradient id=\"inventory-edge\"><stop stop-color=\"#674276\"/><stop offset=\".45\" stop-color=\"#3c2c4e\"/><stop offset=\"1\" stop-color=\"#272335\"/></linearGradient>";
export const APPROVED_ICON_ARTWORK = {
  "heart": {
    "viewBox": "0 0 32 32",
    "body": "<path d=\"M16 28 4 16Q-1 5 8 3q5-1 8 5 3-6 8-5 9 2 4 13Z\"/>",
    "strokeWidth": 1.5,
    "opacity": 1
  },
  "bag": {
    "viewBox": "0 0 32 32",
    "body": "<path d=\"M8 10h16l3 17H5Zm4 0V6q4-5 8 0v4\"/>",
    "strokeWidth": 1.5,
    "opacity": 1
  },
  "player": {
    "viewBox": "0 0 32 32",
    "body": "<circle cx=\"16\" cy=\"8\" r=\"5\"/><path d=\"M6 29v-6q0-8 10-8t10 8v6\"/>",
    "strokeWidth": 1.5,
    "opacity": 1
  },
  "settings": {
    "viewBox": "0 0 32 32",
    "body": "<path d=\"M4 8h24M4 16h24M4 24h24M11 4v8M22 12v8M14 20v8\"/>",
    "strokeWidth": 1.5,
    "opacity": 1
  },
  "close": {
    "viewBox": "0 0 32 32",
    "body": "<path d=\"m7 7 18 18M25 7 7 25\"/>",
    "strokeWidth": 1.5,
    "opacity": 1
  },
  "check": {
    "viewBox": "0 0 32 32",
    "body": "<path d=\"m6 17 6 6L26 9\"/>",
    "strokeWidth": 1.5,
    "opacity": 1
  },
  "arrow": {
    "viewBox": "0 0 32 32",
    "body": "<path d=\"M5 27 27 5M18 5h9v9M5 18v9h9\"/>",
    "strokeWidth": 1.5,
    "opacity": 1
  },
  "more": {
    "viewBox": "0 0 32 32",
    "body": "<circle cx=\"7\" cy=\"16\" r=\"1\"/><circle cx=\"16\" cy=\"16\" r=\"1\"/><circle cx=\"25\" cy=\"16\" r=\"1\"/>",
    "strokeWidth": 1.5,
    "opacity": 1
  },
  "star": {
    "viewBox": "0 0 32 32",
    "body": "<path d=\"m16 2 3 11 11 3-11 3-3 11-3-11-11-3 11-3Z\"/><circle cx=\"16\" cy=\"16\" r=\"9\"/>",
    "strokeWidth": 1.5,
    "opacity": 1
  },
  "move": {
    "viewBox": "0 0 32 32",
    "body": "<path d=\"M3 16h26m-8-8 8 8-8 8M11 8 3 16l8 8\"/>",
    "strokeWidth": 1.5,
    "opacity": 1
  },
  "drop": {
    "viewBox": "0 0 32 32",
    "body": "<path d=\"M16 3v18m-7-7 7 7 7-7M4 24v5h24v-5\"/>",
    "strokeWidth": 1.5,
    "opacity": 1
  },
  "helmet": {
    "viewBox": "0 0 48 48",
    "body": "<path d=\"M9 33V22C9 10 16 6 24 6S39 10 39 22V33L31 38V25H17V38ZM13 22H35M24 7V17\"/>",
    "strokeWidth": 1.2,
    "opacity": 0.64
  },
  "coat": {
    "viewBox": "0 0 48 48",
    "body": "<path d=\"M17 7L24 12L31 7L43 17L37 27L32 23V41H16V23L11 27L5 17ZM24 12V39M18 8L20 17L24 14L28 17L30 8\"/>",
    "strokeWidth": 1.2,
    "opacity": 0.64
  },
  "pants": {
    "viewBox": "0 0 48 48",
    "body": "<path d=\"M13 7H35L37 40H27L24 22L21 40H11ZM13 13H35M24 7V19\"/>",
    "strokeWidth": 1.2,
    "opacity": 0.64
  },
  "boots": {
    "viewBox": "0 0 48 48",
    "body": "<path d=\"M10 7H23V27L29 32V40H7V33L10 27ZM28 8H39V25L44 30V37H33M10 15H23M28 15H39\"/>",
    "strokeWidth": 1.2,
    "opacity": 0.64
  },
  "emptyHand": {
    "viewBox": "0 0 48 48",
    "body": "<path d=\"M14 40 8 27q-2-5 2-5l7 6V13q0-5 4-2v12V7q2-4 4 0v16V10q4-3 4 2v12-6q3-4 5 0v13l-6 9Z\"/><path d=\"m9 41 30-30\"/>",
    "strokeWidth": 1.3,
    "opacity": 1
  }
} as const;
export type ApprovedIconName = keyof typeof APPROVED_ICON_ARTWORK;
const artworkSources = new Map<string, string>();
function cachedArtwork(key: string, create: () => string): string {
 const cached = artworkSources.get(key);
 if (cached !== undefined) return cached;
 const source = create();
 if (artworkSources.size >= 128) artworkSources.delete(artworkSources.keys().next().value!);
 artworkSources.set(key, source);
 return source;
}
export function approvedHealthBarSvg(width: number, fraction: number): string {
 return cachedArtwork(`health:${width}:${fraction}`, () => `<svg xmlns="http://www.w3.org/2000/svg" width="${width + 12}" height="24" viewBox="-6 -6 ${width + 12} 24"><defs>${APPROVED_STYLE_DEFS}</defs><g filter="url(#hud-shadow)"><rect width="${width}" height="8" fill="#10141c" fill-opacity=".3"/><rect width="${width * fraction}" height="8" fill="${fraction < .3 ? '#efb0a7' : 'url(#hp-fill)'}"/></g></svg>`);
}
export const PORTAL_BLEED = 48;
export const PORTAL_WINDOW_INSETS = [48, 48, 48, 48] as const;
export const PORTAL_REFERENCE_SIZE = [470, 550] as const;
export function portalSurface(w: number,h: number,id: string){
 const f=(n: number)=>Number(n.toFixed(2));
 const points: number[][]=[];
 const edges=[{n:30,xy:(t: number)=>[t*w,-2+4*Math.sin(t*18)+2*Math.sin(t*43)]},{n:34,xy:(t: number)=>[w+2+3*Math.sin(t*21)+2*Math.sin(t*51),t*h]},{n:30,xy:(t: number)=>[(1-t)*w,h+2+4*Math.sin(t*20)+2*Math.sin(t*47)]},{n:34,xy:(t: number)=>[-2+3*Math.sin(t*22)+2*Math.sin(t*53),(1-t)*h]}];
 for(const edge of edges)for(let i=0;i<edge.n;i++)points.push(edge.xy(i/edge.n).map(f));
 const boundary='M'+points.map(p=>p.join(' ')).join('L')+'Z';
 let ribbons='';
 for(let side=0;side<4;side++)for(let i=0;i<8;i++){
  const len=side%2?h:w,start=12+i*(len-40)/8,span=Math.min(80+((i*37+side*19)%86),len-start-8),out=3+((i*11+side*5)%5),curl=3+((i*7)%5);
  const transform=side===0?'':side===1?`translate(${w} 0) rotate(90)`:side===2?`translate(${w} ${h}) rotate(180)`:`translate(0 ${h}) rotate(-90)`;
  const a=f(start),b=f(start+span*.36),c=f(start+span*.72),d=f(start+span);
  ribbons+=`<g transform="${transform}"><path d="M${a} 9C${b} ${-out} ${c} ${out*.6} ${d} ${-out-curl}C${d-5} ${-out+8} ${c+12} 8 ${b+7} 7S${a+16} 13 ${a} 9Z" fill="${i%3===0?'#826295':i%3===1?'#41334f':'#262432'}" opacity="${i%3===0?.16:.42}"/><path d="M${a-5} 12C${b-4} ${-out-4} ${c} ${out*.4-3} ${d-9} ${-out-curl+3}" fill="none" stroke="#b293cc" stroke-width="${i%2?.5:.8}" opacity=".12"/></g>`;
 }
 return `<g aria-hidden="true"><defs><filter id="${id}-fray" x="-12%" y="-12%" width="124%" height="124%"><feTurbulence type="fractalNoise" baseFrequency=".042 .09" numOctaves="2" seed="12" result="noise"/><feDisplacementMap in="SourceGraphic" in2="noise" scale="8" xChannelSelector="R" yChannelSelector="G"/></filter><linearGradient id="${id}-edge"><stop stop-color="#674276"/><stop offset=".45" stop-color="#3c2c4e"/><stop offset="1" stop-color="#272335"/></linearGradient></defs><path d="${boundary}" fill="url(#panel)" filter="url(#window-shadow)"/><path d="${boundary}" fill="url(#panel)" filter="url(#${id}-fray)"/>${ribbons}<path d="M-10 87C-30 54-15 11 38 4C88-3 119 14 156-2C127 21 98 12 59 16C21 20 4 38 4 65C4 83-7 95-16 82C-22 70-13 57-5 66" fill="none" stroke="url(#${id}-edge)" stroke-width="1.4" opacity=".28"/><path d="M${w+10} ${h-87}C${w+30} ${h-54} ${w+15} ${h-11} ${w-38} ${h-4}C${w-88} ${h+3} ${w-119} ${h-14} ${w-156} ${h+2}C${w-127} ${h-21} ${w-98} ${h-12} ${w-59} ${h-16}C${w-21} ${h-20} ${w-4} ${h-38} ${w-4} ${h-65}C${w-4} ${h-83} ${w+7} ${h-95} ${w+16} ${h-82}C${w+22} ${h-70} ${w+13} ${h-57} ${w+5} ${h-66}" fill="none" stroke="url(#${id}-edge)" stroke-width="1.4" opacity=".28"/></g>`;
}
export function portalMark(x: number,y: number,size=26,color='#e1edaa',opacity=1){let arms='';for(let i=0;i<3;i++){const ps=[];for(let j=0;j<=36;j++){const r=.16+j/36*.84,theta=i*Math.PI*2/3-2.2/(r+.35);ps.push([16+Math.cos(theta)*r*14,16+Math.sin(theta)*r*14]);}arms+=`<path d="M${ps.map(p=>p.map(n=>n.toFixed(2)).join(' ')).join('L')}"/>`;}return `<svg x="${x}" y="${y}" width="${size}" height="${size}" viewBox="0 0 32 32" fill="none" stroke="${color}" stroke-width="1.2" stroke-linecap="round" opacity="${opacity}" aria-hidden="true">${arms}</svg>`;}

export function approvedIconSvg(name: ApprovedIconName, color = '#f4f0e6'): string {
 const a = APPROVED_ICON_ARTWORK[name];
 if (!/^#[0-9a-f]{3,8}$/i.test(color)) throw new Error('Expected a hexadecimal icon color');
 return cachedArtwork(`icon:${name}:${color}`, () => `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="${a.viewBox}" fill="none" stroke="${color}" stroke-width="${a.strokeWidth}" stroke-opacity="${a.opacity}" stroke-linecap="round" stroke-linejoin="round">${a.body}</svg>`);
}
export function portalWindowSvg(width = 470, height = 550, id = 'approved-window'): string {
 if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0 || !/^[a-z][a-z0-9-]*$/i.test(id)) throw new Error('Invalid portal artwork size or ID');
 return cachedArtwork(`window:${width}:${height}:${id}`, () => `<svg xmlns="http://www.w3.org/2000/svg" width="${width+96}" height="${height+96}" viewBox="-48 -48 ${width+96} ${height+96}" preserveAspectRatio="none"><defs>${APPROVED_STYLE_DEFS}</defs>${portalSurface(width,height,id)}</svg>`);
}
export const PORTAL_WINDOW_SVG = portalWindowSvg();
export const PORTAL_MARK_SVG = portalMark(0, 0, 32).replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" ');

export function approvedRadialSvg(count = 7, selected = 0): string {
 if (!Number.isInteger(count) || count < 1 || count > 24 || !Number.isInteger(selected)) throw new Error('Invalid radial artwork state');
 return cachedArtwork(`radial:${count}:${selected}`, () => {
 const step = 360 / count;
 const polar = (radius: number, degrees: number) => [300 + Math.cos(degrees * Math.PI / 180) * radius, 300 + Math.sin(degrees * Math.PI / 180) * radius];
 const arc = (radius: number, from: number, to: number) => `M${polar(radius,from)} A${radius} ${radius} 0 ${to-from > 180 ? 1 : 0} 1 ${polar(radius,to)}`;
 const wedge = (from: number, to: number) => `${arc(219,from,to)} L${polar(98,to)} A98 98 0 ${to-from > 180 ? 1 : 0} 0 ${polar(98,from)} Z`;
 let sectors = '';
 for (let i = 0; i < count; i++) {
  const angle = -90 + i * step, lo = angle-step/2+2, hi = angle+step/2-2;
  sectors += `<path d="${wedge(lo,hi)}" fill="${i === selected ? '#353b32' : '#171822'}" fill-opacity="${i === selected ? '.88' : '.72'}"/><path d="${arc(219,lo,hi)}" fill="none" stroke="#f2e8ff" stroke-opacity=".4" stroke-width="1"/><path d="M${polar(212,lo)}L${polar(219,lo)}M${polar(212,hi)}L${polar(219,hi)}" fill="none" stroke="#f2e8ff" stroke-opacity=".5"/>`;
 }
 return `<svg xmlns="http://www.w3.org/2000/svg" width="600" height="600" viewBox="0 0 600 600">${sectors}${selected < 0 ? '' : `<g transform="rotate(${selected*step} 300 300)"><path d="${arc(222,-90-step/2+2,-90+step/2-2)}" fill="none" stroke="#e1edaa" stroke-width="3"/><path d="m300 64 4 6-4 6-4-6Z" fill="#e1edaa"/><path d="m300 208-4-7h8Z" fill="#e1edaa"/></g>`}</svg>`;
 });
}
